export default __webpack_public_path__ + "static/media/real-case-bg.9a44bfd1.png";